import { render, staticRenderFns } from "./RegistrationGuidePdfModal.vue?vue&type=template&id=c06b64c4&scoped=true&lang=pug"
import script from "./RegistrationGuidePdfModal.vue?vue&type=script&lang=ts"
export * from "./RegistrationGuidePdfModal.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationGuidePdfModal.vue?vue&type=style&index=0&id=c06b64c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06b64c4",
  null
  
)

export default component.exports